<template>
  <v-card flat>
    <v-col cols="12" class="px-0">
      <v-btn color="primary" icon @click="beforeLeave">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <span class="text-h6 mr-2" style="vertical-align: middle">
        {{ $t('message.pages.video.chapters') }}
      </span>
    </v-col>

    <v-col cols="12">
      <v-card flat>
        <span>
          {{ $t('message.pages.video.messageChapters') }}
        </span>
      </v-card>
    </v-col>

    <v-card v-if="arrayChapters.length > 0" flat class="ml-2">
      <v-row no-gutters>
        <v-col cols="12" v-for="(chapter, i) in arrayChapters" :key="i">
          <v-card class="mt-2" outlined>
            <v-row class="pt-1" no-gutters justify="center" align="center">
              <v-col cols="1" class="pl-4">
                <span
                  class="dot"
                  style="
                    background-color: rgb(0, 173, 239);
                    width: 0.5rem;
                    height: 0.5rem;
                    border-radius: 50%;
                    display: inline-block;
                  "
                ></span>
              </v-col>
              <v-col cols="3" class="pa-0 container-title-description">
                <v-text-field
                  v-model="chapter.timeFormated"
                  hide-details
                  outlined
                  color="primary"
                  ref="timeChapter"
                  :disabled="loadingButtonSave || !hasEditVideoPerm"
                  @blur="editChapter(i)"
                >
                </v-text-field>
              </v-col>

              <v-col cols="6" class="pa-0 container-title-description">
                <v-text-field
                  v-model="chapter.title"
                  placeholder="Título do Capítulo"
                  hide-details
                  outlined
                  color="primary"
                  ref="titleChapter"
                  @blur="editChapter(i)"
                  @focus="inputBeingEdited(i, 'titleChapter')"
                  :class="{ inputActive: i + 'titleChapter' === activeInput }"
                  :disabled="loadingButtonSave || !hasEditVideoPerm"
                >
                </v-text-field>
              </v-col>
              <v-spacer />
              <v-col cols="2" class="pa-0">
                <v-btn
                  plain
                  icon
                  @click="removeChapter(i)"
                  color="#f44336"
                  :disabled="loadingButtonSave || !hasEditVideoPerm"
                  class="d-table"
                  style="margin: 0 auto"
                >
                  <v-icon> mdi-delete </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-card>

    <span
      v-if="checkValidateInputsChapter()"
      class="red--text caption align-text ml-2 mt-2 d-block"
    >
      {{ errorMessage }}
    </span>

    <span
      v-if="internalError"
      class="red--text caption align-text ml-2 mt-2 d-block"
    >
      <v-icon color="red" size="16" class="mt-n1"> mdi-alert-circle </v-icon>
      {{ $t('message.pages.video.errors.addChapter') }}
    </span>

    <v-card
      style="border-style: dashed"
      class="my-2 py-2 ml-2"
      outlined
      hover
      @click="addChapter(), checkValidateInputsChapter()"
      :disabled="checkValidateInputsChapter() || loadingButtonSave"
      v-if="hasEditVideoPerm"
    >
      <v-btn plain icon>
        <v-icon> mdi-plus </v-icon>
      </v-btn>
      <span style="font-size: 16px; margin-top: 7px; display: inline-block">{{
        $t('message.pages.video.new')
      }}</span>
    </v-card>

    <v-row no-gutters v-if="hasEditVideoPerm">
      <v-col cols="12">
        <v-card-actions class="px-0 pt-8 pb-6">
          <v-spacer></v-spacer>
          <v-btn
            class="mr-2 px-4"
            text
            :disabled="loadingButtonSave || withoutChanges"
            @click="handleUndoChanges"
          >
            {{ $t('message.pages.video.discardChanges') }}
          </v-btn>
          <v-btn
            color="primary"
            class="px-6"
            @click="handleUpdateChapters"
            :disabled="
              loadingButtonSave ||
              checkValidateInputsChapter() ||
              withoutChanges
            "
            :loading="loadingButtonSave"
          >
            {{ $t('message.pages.video.publish') }}
          </v-btn>
        </v-card-actions>
      </v-col>
    </v-row>
    <unsaved-changes-modal />
  </v-card>
</template>

<script>
import UnsavedChangesModal from '../../../components/UnsavedChangesModal.vue'
import { mapActions, mapMutations, mapState } from 'vuex'
import { mask } from 'vue-the-mask'
import _ from 'lodash'
import i18n from '@/translations/lang'

export default {
  name: 'VideoPlayerChapters',
  components: {
    UnsavedChangesModal,
  },
  directives: { mask },
  props: {
    handleBack: {
      type: Function,
      required: true,
    },
    liveVideoId: {
      required: false,
    },
    hasEdit: {
      type: Array,
    },
  },
  data: () => ({
    videoId: '',
    loadingButtonSave: false,
    initialConfig: {
      arrayChapters: [],
    },
    timeVideo: 0,
    repeatedTimeChapter: 0,
    videoCurrentTime: 0,
    errorMessage: '',
    arrayChapters: [],
    newChapter: {
      title: '',
      time: 0,
      timeFormated: '00:00',
    },
    activeInput: null,
    withoutChanges: true,
  }),
  mounted() {
    this.videoId = this.liveVideoId ? this.liveVideoId : this.$route.params.id
    this.arrayChapters = this.$store.state.video.video.config?.bookMarks
    this.timeVideo = this.$store.state.video.video?.length
    this.newChapter.title = this.$t('message.pages.video.chaptersTitle')
    if (!this.arrayChapters) {
      this.arrayChapters = []
      this.initialConfig.arrayChapters = []
    }
    for (const object of this.arrayChapters) {
      if (object.time) {
        object['timeFormated'] = this.formatTime(object.time)
      }
    }
    this.initialConfig.arrayChapters = _.cloneDeep(this.arrayChapters)
    this.hasEdit.push(this.checkChanges)
    this.changePlayer()
    window.addEventListener(
      'message',
      (event) => {
        const { data } = event
        if (data.message === 'panda_timeupdate') {
          this.videoCurrentTime = Math.round(data.currentTime)
        }
      },
      '*'
    )
    this.$root.$on('discardChanges', () => {
      this.handleUndoChanges()
      this.handleBack()
    })
  },
  beforeDestroy() {
    this.arrayChapters = _.cloneDeep(this.initialConfig.arrayChapters)
    this.changePlayer()
  },
  watch: {
    '$store.state.video.video': {
      handler() {
        this.withoutChanges = this.checkChanges()
      },
      deep: true,
    },
    arrayChapters: {
      handler() {
        this.withoutChanges = this.checkChanges()
      },
      deep: true,
    },
  },
  computed: {
    ...mapState({
      video: (state) => state.video.video,
      profile_id: (state) => state.video.profile_id,
      internalError: (state) => state.video.internalError,
    }),
    hasEditVideoPerm() {
      return (
        this.$store.state.user.userPermissions?.includes('put-video') ?? false
      )
    },
  },
  methods: {
    ...mapActions('video', [
      'updateChapter',
      'createProfile',
      'setProfileToVideos',
    ]),
    ...mapMutations('video', ['UPDATE_VIDEO', 'UPDATE_STATUS_ERROR']),
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    async handleUpdateChapters() {
      this.loadingButtonSave = true
      if (!this.video.config.profile) {
        await this.createProfile(this.videoId)
        this.video.config.profile = this.profile_id
        this.profileId = this.profile_id
        await this.setProfileToVideos([this.profileId, this.videoId])
      }
      this.arrayChapters.forEach((object) => {
        delete object['timeFormated']
      })
      try {
        await this.updateChapter([this.videoId, this.arrayChapters])
        for (const object of this.arrayChapters) {
          if (object.time || object.time === 0) {
            object['timeFormated'] = this.formatTime(object.time)
          }
        }
        this.loadingButtonSave = false
        this.internalError
          ? ''
          : ((this.initialConfig.arrayChapters = _.cloneDeep(
              this.arrayChapters
            )),
            this.handleSnackbar(this.$t('message.pages.video.changesSaved')),
            (this.withoutChanges = true))
      } catch (e) {
        console.error(e)
        this.loadingButtonSave = false
      }
      this.$root.$emit('updateEmbedPreviewChange')
    },
    changePlayer() {
      const pandaPlayer = document.getElementById('panda-player')
      if (pandaPlayer) {
        const iframe = pandaPlayer.contentWindow
        iframe.postMessage(
          {
            type: 'bookMarks',
            parameter: {
              bookMarks: this.arrayChapters,
            },
          },
          '*'
        )
        this.video.config.bookMarks = this.arrayChapters
        this.UPDATE_VIDEO(this.video)
        this.UPDATE_STATUS_ERROR(false)
      } else if (this.video) {
        this.video.config.bookMarks = this.arrayChapters
        this.UPDATE_VIDEO(this.video)
        this.UPDATE_STATUS_ERROR(false)
        this.$root.$emit('setBookmarks', this.arrayChapters)
      }
    },
    handleUndoChanges() {
      this.arrayChapters = _.cloneDeep(this.initialConfig.arrayChapters)
      this.changePlayer()
    },
    checkChanges() {
      return _.isEqual(
        this.video.config.bookMarks,
        this.initialConfig.arrayChapters
      )
    },
    beforeLeave() {
      if (!this.checkChanges()) {
        this.$root.$emit('unsavedChangesModal')
      } else {
        this.UPDATE_STATUS_ERROR(false)
        this.handleBack()
      }
    },
    addChapter() {
      this.arrayChapters.push({
        time: this.videoCurrentTime,
        title: this.newChapter.title,
        timeFormated: this.formatTime(this.videoCurrentTime),
      })
      this.changePlayer()
    },
    removeChapter(index) {
      this.arrayChapters.splice(index, 1)
      this.changePlayer()
    },
    editChapter(index) {
      this.activeInput = ''
      let time = this.arrayChapters[index].timeFormated.split(':')
      let seconds = +time[0] * 60 + +time[1]
      let input = this.arrayChapters[index].timeFormated
      if (this.timeVideo >= 3600) {
        if (time.length === 2) {
          this.arrayChapters[index].timeFormated = [
            input.slice(0, 0),
            '00:',
            input.slice(0),
          ].join('')
          seconds = +time[0] * 60 + +time[1]
        } else if (time.length === 1) {
          this.arrayChapters[index].timeFormated = [
            input.slice(0, 0),
            '00:00:',
            input.slice(0),
          ].join('')
          seconds = +time[0]
        } else {
          seconds = +time[0] * 60 * 60 + +time[1] * 60 + +time[2]
        }
      } else {
        if (time.length === 1) {
          this.arrayChapters[index].timeFormated = [
            input.slice(0, 0),
            '00:',
            input.slice(0),
          ].join('')
          seconds = +time[0]
        }
      }
      if (seconds > this.timeVideo) {
        this.arrayChapters[index].timeFormated = this.formatTime(
          this.timeVideo - 1
        )
      }

      if (this.arrayChapters[index].time !== seconds) {
        this.arrayChapters[index].time = seconds
      }
      if (this.arrayChapters[index].time > this.timeVideo) {
        this.arrayChapters[index].time = this.timeVideo
        this.arrayChapters[index].timeFormated = this.formatTime(this.timeVideo)
      }

      this.changePlayer()
    },
    checkValidateInputsChapter() {
      let tmpArr = []
      let error = false

      if (this.arrayChapters.length > 0) {
        this.arrayChapters.forEach(({ time, title }) => {
          if (tmpArr.indexOf(time) < 0) {
            tmpArr.push(time)
            if (title.length < 3) {
              this.errorMessage = i18n.t(
                'message.pages.videoPlayerChapters.errors.titleSize'
              )

              error = true
            }
          } else {
            error = true
            this.repeatedTimeChapter = this.formatTime(time)
            this.errorMessage = i18n.t(
              'message.pages.videoPlayerChapters.errors.duplicatedChapter',
              {
                chapter: this.repeatedTimeChapter,
              }
            )
          }
        })
      }

      if (!error) this.errorMessage = ''

      return Boolean(this.errorMessage)
    },
    inputBeingEdited(i, ref) {
      this.activeInput = i
      if (ref) {
        this.activeInput = i + ref
      }
    },
    formatTime(seconds) {
      const h = Math.floor(seconds / 3600)
      const m = Math.floor((seconds % 3600) / 60)
      const s = Math.round(seconds % 60)
      if (this.seconds === 0) {
        return '00:00'
      }
      if (this.timeVideo >= 3600) {
        return [
          h > 9 ? h : h ? '0' + h : '0' + h || '00',
          m > 9 ? m : h ? '0' + m : '0' + m || '00',
          s > 9 ? s : '0' + s,
        ]
          .filter(Boolean)
          .join(':')
      } else {
        return [m > 9 ? m : h ? '0' + m : '0' + m || '00', s > 9 ? s : '0' + s]
          .filter(Boolean)
          .join(':')
      }
    },
    handleSnackbar(item) {
      if (!item) {
        item = i18n.t('message.changesSaved')
      }
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: item,
      })
    },
  },
}
</script>

<style></style>
